document.addEventListener('DOMContentLoaded', function () {
  // Hero slider autoplay + dots
  var heroSlider = document.getElementById('HeroSlider');
  if (heroSlider) {
    var slides = heroSlider.querySelectorAll('.hero-slide');
    var dots = heroSlider.querySelectorAll('.hero-dot');
    var idx = 0;
    function showSlide(i) {
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      idx = i;
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { showSlide(i); });
    });
    if (slides.length > 1) {
      setInterval(function () { showSlide((idx + 1) % slides.length); }, 5000);
    }
  }

  // Scroll-reveal for main content sections
  var revealTargets = document.querySelectorAll('#MainContent .shopify-section');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealTargets.forEach(function (el) { observer.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('is-visible'); });
  }
});
